<template>
  <div class="app-shortcuts-dock">
    <div class="app-shortcuts-dock-container">
      <div class="app-shortcuts-dock-btn">
        <div class="app-shortcuts-dock-tooltip">NextGen Academy</div>
        <a
          :href="`https://nextgen-academy.ai/?token=${token}`"
          target="_blank"
          rel="noopener"
        >
          <img src="/images/intro/nextgen-academy.png" alt="App Icon 1" />
        </a>
      </div>
      <div class="app-shortcuts-dock-divider"></div>
      <div class="app-shortcuts-dock-btn">
        <div class="app-shortcuts-dock-tooltip">Lingo Lango</div>
        <a
          :href="`https://lingo-lango.com/?token=${token}`"
          target="_blank"
          rel="noopener"
        >
          <img src="/images/intro/LingoLango.png" alt="Lingo Lango" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { webstore } from "../helpers/auth-helpers.js";

export default {
  data: () => ({
    token:
      new URL(window.location.href).searchParams.get("token") ||
      webstore.getProperty("token") ||
      "",
  }),
};
</script>

<style lang="scss">
.app-shortcuts-dock {
  position: fixed;
  bottom: 18px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  z-index: 50;

  .app-shortcuts-dock-container {
    display: flex;
    align-items: center;
    background-color: rgba(30, 30, 45, 0.88);
    border-radius: 22px;
    padding: 6px 8px;
  }

  .app-shortcuts-dock-btn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover .app-shortcuts-dock-tooltip {
      opacity: 1;
      transform: translateX(-50%) translateY(-4px);
    }

    img {
      width: 64px;
      height: 64px;
      border-radius: 14px;
      cursor: pointer;
      display: block;
    }
  }

  .app-shortcuts-dock-tooltip {
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%) translateY(0);
    background-color: rgba(40, 40, 55, 0.95);
    color: white;
    font-family: "Helvetica Neue Light", sans-serif;
    font-weight: 400;
    font-size: 13px;
    padding: 11px 10px;
    border-radius: 12px;
    white-space: nowrap;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s, transform 0.2s;

    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border: 6px solid transparent;
      border-top-color: rgba(40, 40, 55, 0.95);
    }
  }

  .app-shortcuts-dock-divider {
    width: 1px;
    height: 44px;
    background-color: rgba(255, 255, 255, 0.25);
    margin: 0 8px;
  }

  // Tablet
  @media screen and (max-width: 768px) {
    bottom: 14px;

    .app-shortcuts-dock-container {
      border-radius: 18px;
      padding: 5px 6px;
    }

    .app-shortcuts-dock-btn img {
      width: 52px;
      height: 52px;
      border-radius: 12px;
    }

    .app-shortcuts-dock-divider {
      height: 36px;
      margin: 0 6px;
    }

    .app-shortcuts-dock-tooltip {
      font-size: 12px;
      padding: 3px 9px;
    }
  }

  // Mobile portrait
  @media screen and (max-width: 480px) {
    bottom: 10px;

    .app-shortcuts-dock-container {
      border-radius: 16px;
      padding: 4px 6px;
    }

    .app-shortcuts-dock-btn img {
      width: 44px;
      height: 44px;
      border-radius: 10px;
    }

    .app-shortcuts-dock-divider {
      height: 30px;
      margin: 0 5px;
    }

    .app-shortcuts-dock-tooltip {
      font-size: 11px;
      padding: 3px 8px;
      border-radius: 10px;
    }
  }

  // Landscape on small screens
  @media screen and (max-height: 420px) {
    bottom: 6px;

    .app-shortcuts-dock-btn img {
      width: 38px;
      height: 38px;
      border-radius: 8px;
    }

    .app-shortcuts-dock-divider {
      height: 26px;
    }
  }
}
</style>
